import { render } from "./Main.vue?vue&type=template&id=65c9c144&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=65c9c144&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=65c9c144&lang=css"
script.render = render
script.__scopeId = "data-v-65c9c144"

export default script